export const ITEM_LIST_DATA = 'ITEM_LIST_DATA';
export const ITEM_DATA_LOADING = 'ITEM_DATA_LOADING';
export const ITEM_DATA_LIST_ERROR = 'ITEM_DATA_LIST_ERROR';
export const PRINT_BARCODE_LOADING = 'PRINT_BARCODE_LOADING';
export const PRINT_BARCODE_DATA = 'PRINT_BARCODE_DATA';
export const SET_PRINT_RESPONSE_EMPTY = 'SET_PRINT_RESPONSE_EMPTY';
export const PRINT_BARCODE_ERROR = 'PRINT_BARCODE_ERROR';
export const CLEAR_PRINT_ERROR = 'CLEAR_PRINT_ERROR';
export const RESET_PRINT_RESPONSE = 'RESET_PRINT_RESPONSE';



// WEBPACK FOOTER //
// ./src/pages/utilities/state/printBarcodes/types.js